import axios from 'axios';
import {token} from '../services/Authentication'

export default class PrincipalService {


  static initiaslParam() {
      
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/principal`,
      headers: {              
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

}
